// gen
// const baseUrl = "http://dg.ampacetech.com/api";
// const baseUrl = "http://xmxna-dev.leezi.cn/api";
// const baseUrl = "http://xmxna-dev.liuyunchuan.com/api";
// const baseUrl = "http://xmxna.ubooking.cn/api";
// const baseUrl = "http://gdxna.ubooking.cn/api";
// dev
const baseUrl = "https://xmxna-dev.liuyunchuan.com/api";
// const baseUrl = "https://visitor.ampacepower.com/api";
export default {
  baseUrl
};



// WEBPACK FOOTER //
// ./src/global/constant.js